module.exports = __webpack_public_path__ + "img/rw.e8cfe768.svg";